import { useTranslation } from "react-i18next";

const WHATSAPP_NUMBER = "917982959943";

export const WhatsappFloat = () => {
    const { t } = useTranslation();
    const preset = encodeURIComponent(t("whatsapp.preset"));
    return (
        <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${preset}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float-btn"
            className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 pl-3 pr-5 py-3 rounded-full bg-[#25D366] text-white animate-whatsapp-pulse hover:bg-[#1ebd58] transition-colors"
            aria-label="Connect on WhatsApp"
            dir="ltr"
        >
            <span className="h-9 w-9 rounded-full bg-white/15 flex items-center justify-center">
                <svg
                    viewBox="0 0 32 32"
                    className="h-5 w-5 fill-current"
                    aria-hidden
                >
                    <path d="M19.11 17.21c-.27-.13-1.59-.78-1.84-.87-.25-.09-.42-.13-.6.13-.18.27-.69.87-.85 1.05-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.16-1.33-.8-.71-1.34-1.59-1.49-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.83-1.99-.22-.52-.44-.45-.6-.46-.16-.01-.34-.01-.52-.01-.18 0-.47.07-.72.34-.25.27-.94.92-.94 2.25 0 1.33.96 2.61 1.1 2.79.13.18 1.89 2.88 4.58 4.04.64.28 1.14.44 1.53.57.64.2 1.22.17 1.68.1.51-.08 1.59-.65 1.81-1.28.22-.62.22-1.16.16-1.27-.07-.11-.25-.18-.52-.32M16.04 27.78h-.04c-1.83 0-3.62-.49-5.19-1.43l-.37-.22-3.85 1.01 1.03-3.76-.24-.39a10.43 10.43 0 0 1-1.6-5.57c0-5.76 4.68-10.44 10.44-10.44 2.79 0 5.41 1.09 7.38 3.06a10.37 10.37 0 0 1 3.06 7.39c-.01 5.76-4.69 10.45-10.62 10.45M27.84 4.91a13.84 13.84 0 0 0-19.6 19.62L6 32l7.65-2.01a13.83 13.83 0 0 0 6.63 1.69h.01c7.64 0 13.85-6.21 13.86-13.85 0-3.7-1.44-7.18-4.05-9.79" />
                </svg>
            </span>
            <span className="hidden sm:inline text-sm font-semibold">
                {t("whatsapp.chat")}
            </span>
            <span
                className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-emerald-400 ring-2 ring-white"
                aria-hidden
            />
        </a>
    );
};
